import { PosAbsolute, PosRelative } from '@layout/BuildingBlocks'
import React from 'react'

export const MarketsIcon = ({
  size = 32,
  width,
  iconColor = '#4C4D4C',
  backgroundColor = '#CFDE40',
  strokeWidth,
  shadow = true,
}) => {
  return (
    <PosRelative width={width || size} height="100%">
      <PosAbsolute>
        <svg
          width={width || size}
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="19.5" cy="13.5" r="12.5" fill={backgroundColor} />
        </svg>
      </PosAbsolute>
      <PosAbsolute>
        <svg
          width={width || size}
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ filter: shadow && 'drop-shadow(0 5px 3px #bfbfbf)' }}
        >
          <path
            d="M27.5 7H3.5C3.36739 7 3.24021 7.05268 3.14645 7.14645C3.05268 7.24021 3 7.36739 3 7.5C3 7.63261 3.05268 7.75979 3.14645 7.85355C3.24021 7.94732 3.36739 8 3.5 8H4V22.5C4.00042 22.8977 4.15859 23.279 4.43981 23.5602C4.72102 23.8414 5.10231 23.9996 5.5 24H12.8727L11.0627 27.2573C11.0308 27.3147 11.0105 27.3778 11.003 27.4431C10.9955 27.5083 11.0009 27.5744 11.019 27.6376C11.037 27.7007 11.0673 27.7597 11.1082 27.8111C11.149 27.8625 11.1996 27.9054 11.257 27.9373C11.3313 27.9788 11.415 28.0004 11.5 28C11.5893 28.0001 11.6769 27.9762 11.7538 27.931C11.8308 27.8857 11.8942 27.8207 11.9375 27.7427L14.0164 24H16.9837L19.0629 27.7427C19.1062 27.8207 19.1695 27.8856 19.2464 27.9309C19.3233 27.9761 19.4108 28 19.5 28C19.5848 28.0001 19.6682 27.9784 19.7422 27.937C19.7996 27.9051 19.8502 27.8622 19.891 27.8108C19.9319 27.7594 19.9622 27.7004 19.9802 27.6372C19.9983 27.5741 20.0037 27.508 19.9962 27.4428C19.9887 27.3775 19.9684 27.3144 19.9365 27.257L18.1273 24H25.5C25.8977 23.9996 26.279 23.8414 26.5602 23.5602C26.8414 23.279 26.9996 22.8977 27 22.5V8H27.5C27.6326 8 27.7598 7.94732 27.8536 7.85355C27.9473 7.75979 28 7.63261 28 7.5C28 7.36739 27.9473 7.24021 27.8536 7.14645C27.7598 7.05268 27.6326 7 27.5 7ZM26 22.5C26 22.6326 25.9473 22.7598 25.8536 22.8536C25.7598 22.9473 25.6326 23 25.5 23H5.5C5.36739 23 5.24021 22.9473 5.14645 22.8536C5.05268 22.7598 5 22.6326 5 22.5V8H26V22.5ZM7.6465 19.3535C7.55276 19.2597 7.50011 19.1326 7.50011 19C7.50011 18.8674 7.55276 18.7403 7.6465 18.6465L12.6465 13.6465C12.7403 13.5528 12.8674 13.5001 13 13.5001C13.1326 13.5001 13.2597 13.5528 13.3535 13.6465L17 17.293L21.293 13H19.5C19.3674 13 19.2402 12.9473 19.1464 12.8536C19.0527 12.7598 19 12.6326 19 12.5C19 12.3674 19.0527 12.2402 19.1464 12.1464C19.2402 12.0527 19.3674 12 19.5 12H22.5C22.6326 12 22.7598 12.0527 22.8536 12.1464C22.9473 12.2402 23 12.3674 23 12.5V15.5C23 15.6326 22.9473 15.7598 22.8536 15.8536C22.7598 15.9473 22.6326 16 22.5 16C22.3674 16 22.2402 15.9473 22.1464 15.8536C22.0527 15.7598 22 15.6326 22 15.5V13.707L17.3535 18.3535C17.2597 18.4472 17.1326 18.4999 17 18.4999C16.8674 18.4999 16.7403 18.4472 16.6465 18.3535L13 14.707L8.3535 19.3535C8.25974 19.4472 8.13258 19.4999 8 19.4999C7.86742 19.4999 7.74026 19.4472 7.6465 19.3535V19.3535Z"
            fill={iconColor}
            stroke={iconColor}
            strokeWidth={strokeWidth}
          />
        </svg>
      </PosAbsolute>
    </PosRelative>
  )
}
